<template src="./back-to-top.html"></template>

<script>
export default {
};
</script>
